<template>
  <div v-html="content" class="con"></div>
</template>

<script>
export default {
  data() {
    return {
      content: "",
    };
  },
  methods: {
    async getInfoDetails() {
      const { data: res } = await this.$http.get(
        `/api/v2/association/about/${this.$route.params.id}`
      );
      // console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.content = res.data.content;
      this.$zhTran()
    },
  },
  created(){
    // console.log(this.$route.params.id)
    this.getInfoDetails()
  }
};
</script>

<style lang="less" scoped>
.con {
  margin: 0 35px;
  width: 100%;
  box-sizing: border-box;
}
@media screen and (max-width: 768px) {
  .con {
    margin: 10px 0;
    padding: 0 20px;
  }
}
</style>
